import axios from 'axios'
import TokenStorage from '../utils/TokenStorage'
import Header from '../utils/Header'


const ajaxRequest = (config) => {


  const token = TokenStorage.get()
  config.baseURL = process.env.VUE_APP_API_URL
  config.headers = config.headers || {}
  if (token && !config.url.includes('/auth/local')) {
    config.headers[Header.Types.AUTHORIZATION] = Header.getTokenValue(token)
  }

  // Inject populate=* for GET requests to maintain Strapi v3 compatibility
  if (config.method === 'GET' && !config.url.includes('populate')) {
    config.url += config.url.includes('?') ? '&populate=*' : '?populate=*';
  }

  return axios.request(config).then(response => {
    // Strapi v5 adapter: flatten { data: [...] } to [...]
    // Only flatten if it looks like a standard Strapi v5 API response envelope.
    // Entities with their own 'id' and 'data' attribute (such as a checkpoint) are NOT envelopes!
    // Datatables responses have `draw` or `recordsTotal`, which we should NOT flatten.
    if (
      response.data &&
      response.data.data !== undefined &&
      response.data.id === undefined &&
      response.data.draw === undefined &&
      response.data.recordsTotal === undefined
    ) {
      // Store meta just in case
      response.meta = response.data.meta;
      response.data = response.data.data;
    }
    return response
  })
}

const Ajax = {
  get: (endpoint, config = {}) => {
    config = {
      ...config,
      ...{
        url: endpoint,
        method: 'GET'
      }
    }

    return ajaxRequest(config)
  },

  post: (endpoint, params, config = {}) => {
    config = {
      ...config,
      ...{
        url: endpoint,
        method: 'POST',
        data: params
      }
    }

    return ajaxRequest(config)

  },

  put: (endpoint, params, config = {}) => {
    config = {
      ...config,
      ...{
        url: endpoint,
        method: 'PUT',
        data: params
      }
    }

    return ajaxRequest(config)
  },

  delete: (endpoint, params = null, config = {}) => {
    config = {
      ...config,
      ...{
        url: endpoint,
        method: 'DELETE'
      }
    }

    if (params) {
      config.data = params
    }

    return ajaxRequest(config)
  }
}

export default Ajax
